import { Assessment } from "@/types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { formatDate } from "@/utils/date";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Link, useNavigate } from "react-router";
import { StatusBadge } from "../ui/status-badge";
import { Button } from "../ui/button";
import { FiPlus } from "react-icons/fi";

export function RecentAssessments({
  assessments,
}: {
  assessments: Assessment[];
}) {
  const navigate = useNavigate();
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle>Recent assessments</CardTitle>
          <Link
            to="/assessments"
            className="text-sm text-purple-500 hover:underline"
          >
            View all
          </Link>
        </div>
      </CardHeader>
      <CardContent>
        {assessments.length > 0 ? (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Assessment</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Score</TableHead>
                <TableHead>Created</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {assessments.map((assessment) => (
                <TableRow
                  className="cursor-pointer"
                  key={assessment.id}
                  onClick={() => navigate(`/assessments/${assessment.id}`)}
                >
                  <TableCell>{assessment.title}</TableCell>
                  <TableCell>
                    <StatusBadge status={assessment.status} />
                  </TableCell>
                  <TableCell>{(Math.random() * 100).toFixed(0)}%</TableCell>
                  <TableCell>{formatDate(assessment.created_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="py-8 text-center">
            <p className="text-muted-foreground mb-4">No recent assessments found</p>
            <Button onClick={() => navigate("/assessments/new")}>
              <FiPlus className="mr-2 h-4 w-4" />
              Create assessment
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
